import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
const CardsContext = createContext(undefined);
export const CardsProvider = ({ children }) => {
    const [cards, setCards] = useState([]);
    const [userCharacters, setUserCharacters] = useState([]);
    const [selectedCardsIds, setSelectedCardsIds] = useState([]);
    const [activeCombatMap, setActiveCombatMap] = useState(null);
    const [isNextTurnLoading, setIsNextTurnLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isOwnerUser, setIsOwnerUser] = useState(false);
    const [connected, setConnected] = useState(false);
    const [room, setRoom] = useState(null);
    const value = useMemo(() => ({
        cards,
        setCards,
        userCharacters,
        setUserCharacters,
        selectedCardsIds,
        setSelectedCardsIds,
        activeCombatMap,
        setActiveCombatMap,
        isNextTurnLoading,
        setIsNextTurnLoading,
        loading,
        setLoading,
        isOwnerUser,
        setIsOwnerUser,
        connected,
        setConnected,
        room,
        setRoom,
    }), [
        cards,
        userCharacters,
        selectedCardsIds,
        activeCombatMap,
        isNextTurnLoading,
        loading,
        isOwnerUser,
        connected,
        room,
    ]);
    return _jsx(CardsContext.Provider, { value: value, children: children });
};
export const useInitiativeTracker = () => {
    const context = useContext(CardsContext);
    if (!context)
        throw new Error('useCards must be used within a CardsProvider');
    return context;
};
